import { AI_LIMITS, dailyLimitStr, quotaDescriptionStr } from './constants';

// Centralized pricing configuration for easier maintenance
export const pricingPlans = {
  trial: {
    name: '3-Day Free Trial',
    price: 'Free',
    duration: '3 days',
    features: 'Full access to all features'
  },
  monthly: {
    name: 'Monthly Plan',
    price: '$29.99',
    duration: 'month',
    features: 'enhanced AI usage quotas'
  },
  yearly: {
    name: 'Yearly Plan',
    price: '$99.99',
    duration: 'year',
    features: dailyLimitStr(AI_LIMITS.YEARLY_DAILY_QUESTIONS),
    badge: 'best value'
  }
} as const;

// AI usage quotas by plan
export const aiQuotas = {
  trial: { limit: 'limited', description: 'trial users get limited access' },
  monthly: { limit: 'enhanced', description: 'monthly subscribers get enhanced quotas' },
  yearly: { limit: 'maximum', description: quotaDescriptionStr(AI_LIMITS.YEARLY_DAILY_QUESTIONS) }
} as const;